<template>
  <v-dialog v-model="newReportDialog.status" width="500px">
    <v-card>
      <v-card-title>
        Import New Report
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-col md="12">
            <v-text-field v-model="newReportDialog.report_name" label="Report Name" placeholder="陳大文 - 基因測試計劃" outlined></v-text-field>
          </v-col>
          <v-col md="12">
            <v-text-field v-model="newReportDialog.salesGTLCode" type="number" label="SalesGTLCode" placeholder="8000010726" outlined></v-text-field>
          </v-col>
          <v-col md="12">
            <file-pond
              name="report"
              ref="pond"
              label-idle="Drop files here..."
              v-bind:allow-multiple="true"
              server="http://47.244.76.53/api/report_files"
              v-bind:files="newReportDialog.files"/>
          </v-col>
        </v-row>
        ** Please make sure the report name and file name is same
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" outlined @click="addNewReport (newReportDialog.report_name, newReportDialog.salesGTLCode)">Submit</v-btn>
        <v-btn color="grey" outlined @click="newReportDialog.status = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)
export default {
  name: 'index',
  components: {
    FilePond
  },
  data: () => ({
    newReportDialog: {}
  }),
  created () {
    this.newReportDialog = this.$store.state.newReportDialog
  },
  methods: {
    addNewReport (reportName, salesGTLCode) {
      this.$store.commit('addNewReport', {
        reportName: reportName,
        salesGTLCode: salesGTLCode,
        report: 'http://test.com'
      })
      this.newReportDialog.status = false
    }
  }
}
</script>

<style scoped>

</style>
